export default __webpack_public_path__ + "static/media/mfwhatsapp.811cdc82.png";